import {
  FILTER_TABLE,
  SET_INIT_TABLE_CONTENT,
} from "../constans";
import { TABLE_HEADER_INDEX } from "../../constans/statisticsTableConstants";

const initState = {
  headerList: [
    "Hub",
    "Project",
    "Discipline",
    "Model Name",
    "LOD",
    "Checked by",
    "Date of check",
    "Grade"
  ],
  filteredTableContent: [],
  initialTableContent: [],
};


const statisticsTableReducer = (state = initState, { type, payload }) => {

  switch (type) {
    case SET_INIT_TABLE_CONTENT: {
      const { tableData } = payload;
      return { ...state, initialTableContent: tableData, total: tableData.length };
    }

    case FILTER_TABLE : {
      const {filtersValue} = payload

      const filteredTableContent = state.initialTableContent.filter((Row) => {
        const hub = !filtersValue.hub?.length || filtersValue.hub.includes(Row[TABLE_HEADER_INDEX['HUB']])
        const projects = !filtersValue.project?.length ||  filtersValue.project.includes(Row[TABLE_HEADER_INDEX['PROJECT']])
        const model = !filtersValue.model?.length || filtersValue.model.includes(Row[TABLE_HEADER_INDEX['MODEL']])
        const lod = !filtersValue.lod?.length || filtersValue.lod.includes(Row[TABLE_HEADER_INDEX['LOD']])

        return hub && projects && model && lod
      });

      return { ...state, filteredTableContent};
    }

    default:
      return state;
  }
};
export default statisticsTableReducer;
